import { render, staticRenderFns } from "./TileGridSection.vue?vue&type=template&id=672f6bf3&scoped=true"
import script from "./TileGridSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileGridSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TileGridSection.vue?vue&type=style&index=0&id=672f6bf3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672f6bf3",
  null
  
)

export default component.exports